import Ramp from './entities/Ramp';
import { BodyTypes } from '../LevelManager';
import { LevelFeature } from './LevelFeature';
import { RingFeature } from './entities/RingFeature';

export class RampGuide extends Phaser.GameObjects.GameObject {
  public scene: Phaser.Scene;

  protected levelFeature: LevelFeature;
  protected hitbox: MatterJS.BodyType;

  constructor(scene: Phaser.Scene, levelFeature: LevelFeature) {
    super(scene, 'rampGuide');

    this.scene = scene;
    this.levelFeature = levelFeature;

    const guideWidth = 260;
    const guideHeight = 150;

    let blockZone = levelFeature.getBlockZone();

    // let offset = levelFeature instanceof RingFeature ? -80 : -30;
    let offset = -30;

    this.hitbox = this.scene.matter.add.rectangle(blockZone.left - guideWidth * 0.5, levelFeature.getRampEntry() + offset, guideWidth, guideHeight, {
      label: BodyTypes.RampGuide,
      isSensor: true,
    });

    this.hitbox.gameObject = this;
  }

  get LevelFeature(): LevelFeature {
    return this.levelFeature;
  }
}
